import gsap from "gsap/all"
import VideoPlayer from "./ComponentVideos"
import Parrallax from "./Parrallax"



export default function ComponentVideoDouble() {
    let component = document.querySelectorAll('.c-video-double')
    if (component.length > 0) {
        component.forEach(el => new VideoDouble(el))
    }
}

class VideoDouble {
    constructor(el) {
        this.DOM = el
        this.videos = []
        this.animationOnEnterView()
        this.DOM.querySelectorAll('.c-video:nth-child(odd)').forEach((el, index) => new Parrallax(el, -5))
        this.DOM.querySelectorAll('.c-video:nth-child(even)').forEach((el, index) => new Parrallax(el, -20))


        const videos = this.DOM.querySelectorAll('.c-video__video')
        if (videos.length > 0) {
            videos.forEach(video => {
                const newVideo = new VideoPlayer(video)

                video.addEventListener('click', () => {
                    this.videos.forEach(vid => vid.destroy())
                    newVideo.playVideo()
                })
                this.videos.push(newVideo)

            })
        }
    }


    animationOnEnterView() {
        gsap.from(this.DOM.querySelectorAll('.c-video'), {
            scrollTrigger: this.DOM,
            autoAlpha: 0,
            duration: 1,
            stagger: 0.25
        })
    }
}
